import React from "react";
import "../src/css/index.css";
import "../src/css/margins.css";
import "../src/css/typography.css";
import "../src/css/colors.css";
import "../src/css/gaps.css";
import App from "./App";
import "../src/css/index.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.js";


import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

// Suppress ResizeObserver errors that commonly occur with chart libraries
const resizeObserverError = (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded') {
    return;
  }
  console.error(e);
};

window.addEventListener('error', resizeObserverError);

ReactDOM.render(
  <BrowserRouter basename="/">
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);